














import Vue from 'vue';
import AppHeader from '@/components/layout/AppHeader.vue';
import AppDrawer from '@/components/layout/AppDrawer/index.vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'Home',
  components: {
    AppHeader,
    AppDrawer,
  },
  computed: {
    ...mapGetters('auth', ['isLogged']),
  },
});
